// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';



const firebaseConfig = {
  apiKey: "AIzaSyCrHcmBwfUMaJxhsGH92ciTS5GOkyv1Ea8",
  authDomain: "durapot-941ab.firebaseapp.com",
  projectId: "durapot-941ab",
  storageBucket: "durapot-941ab.firebasestorage.app",
  messagingSenderId: "437494313528",
  appId: "1:437494313528:web:b7359fdc8fd86fde7ceccd",
  measurementId: "G-K31VVN0Z4Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const fireDB = getFirestore(app);
const auth = getAuth(app);

export { fireDB, auth,app }